import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate"
//import rootMutaions from './mutations.js' 확장성 염두
//import rootActions from './actions.js'
//import rootGetters from './getters.js'
import counterModule from './modules/counter/index.js'
import coachesModule from './modules/coaches/index.js'
import requestModule from './modules/requests/index.js'
import authModule from './modules/auth/index.js'
import chatModule from './modules/chat/index.js'
import postsModule from './modules/posts/index.js'
import menuModule from './modules/menu/index.js'
import uploadModule from './modules/upload/index.js'
import attendanceModule from './modules/attendance/index.js'
import pointModule from './modules/point/index.js'
import usersModule from './modules/users/index.js'
import itemModule from './modules/item/index.js'
import messageModule from './modules/message/index.js'
import friendModule from './modules/friend/index.js'
import bannerModule from './modules/banner/index.js'
import goodsModule from './modules/goods/index.js'
import settingModule from './modules/setting/index.js'
import paymentModule from './modules/payment/index.js'
const store = createStore({
    modules:{
        numbers : counterModule,
        coaches : coachesModule,
        requests : requestModule,
        auth:authModule,
        chat:chatModule,
        posts:postsModule,
        menu:menuModule,
        upload:uploadModule,
        attendance:attendanceModule,
        point:pointModule,
        users:usersModule,
        item:itemModule,
        message:messageModule,
        friend:friendModule,
        banner:bannerModule,
        goods:goodsModule,
        sets:settingModule,
        payment : paymentModule
    },
    state() {
        return{
            apiURL : 'http://gamejoa.com/api/',
            serverPath: 'http://gamejoa.com',
            serverDomain:'http://gamejoa.com',
            serverDomain2:'http://gamejoa.com/',
            siteName: '게임조아',

        }

    },
    //auth 모듈만 storage에 저장 시킴
    plugins: [
        createPersistedState({
            paths:['auth','menu','banner','users','sets']
        })
    ],
    // mutations:rootMutaions,
    // actions:rootActions,
    //getters: rootGetters //
})

export default store;
